import CheckBoxGroup from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInput'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxLabel'
import ControlGroup from '@pc/components/Works/Panel/shared/ControlGroup'
import MiscHeading from '@pc/components/Works/Panel/shared/Heading/MiscHeading'
import type { FilterCondition } from '@pc/components/Works/Panel/types'
import CheckBoxFeatureInputSet from './CheckBoxFeatureInputSet'
import FeatureBox from './FeatureBox'
import type { ChangeEvent } from 'react'

interface PropsType {
  filterConditions: FilterCondition
  changeState: (arg: any) => void
}

const FilterConditionBox = (props: PropsType) => {
  const { filterConditions, changeState } = props
  const toggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target
    changeState({ filterConditions: { ...filterConditions, [id]: checked } })
  }

  return (
    <FeatureBox>
      <MiscHeading>表示条件</MiscHeading>
      <ControlGroup>
        <CheckBoxGroup>
          <CheckBoxFeatureInputSet>
            <CheckBoxInput
              type="checkbox"
              id="isAcceptHighschoolStudents"
              checked={filterConditions.isAcceptHighschoolStudents}
              onChange={toggleCheckbox}
            />
            <CheckBoxLabel htmlFor="isAcceptHighschoolStudents">高校生不可のバイトを除く</CheckBoxLabel>
          </CheckBoxFeatureInputSet>
          <CheckBoxFeatureInputSet>
            <CheckBoxInput type="checkbox" id="isAcceptStudents" checked={filterConditions.isAcceptStudents} onChange={toggleCheckbox} />
            <CheckBoxLabel htmlFor="isAcceptStudents">学生不可を除く</CheckBoxLabel>
          </CheckBoxFeatureInputSet>
          <CheckBoxFeatureInputSet>
            <CheckBoxInput
              type="checkbox"
              id="isExceptRightHighschoolEducation"
              checked={filterConditions.isExceptRightHighschoolEducation}
              onChange={toggleCheckbox}
            />
            <CheckBoxLabel htmlFor="isExceptRightHighschoolEducation">高卒以上を除く</CheckBoxLabel>
          </CheckBoxFeatureInputSet>
          <CheckBoxFeatureInputSet>
            <CheckBoxInput
              type="checkbox"
              id="isExceptRightCollegeEducation"
              checked={filterConditions.isExceptRightCollegeEducation}
              onChange={toggleCheckbox}
            />
            <CheckBoxLabel htmlFor="isExceptRightCollegeEducation">大卒以上を除く</CheckBoxLabel>
          </CheckBoxFeatureInputSet>
          <CheckBoxFeatureInputSet>
            <CheckBoxInput type="checkbox" id="isExceptMedical" checked={filterConditions.isExceptMedical} onChange={toggleCheckbox} />
            <CheckBoxLabel htmlFor="isExceptMedical">医療バイトを除く</CheckBoxLabel>
          </CheckBoxFeatureInputSet>
          <CheckBoxFeatureInputSet>
            <CheckBoxInput type="checkbox" id="isExceptHaken" checked={filterConditions.isExceptHaken} onChange={toggleCheckbox} />
            <CheckBoxLabel htmlFor="isExceptHaken">派遣バイトを除く</CheckBoxLabel>
          </CheckBoxFeatureInputSet>
          <CheckBoxFeatureInputSet>
            <CheckBoxInput type="checkbox" id="isNewArrival" checked={filterConditions.isNewArrival} onChange={toggleCheckbox} />
            <CheckBoxLabel htmlFor="isNewArrival">新着のアルバイトのみ表示</CheckBoxLabel>
          </CheckBoxFeatureInputSet>
        </CheckBoxGroup>
      </ControlGroup>
    </FeatureBox>
  )
}

export default FilterConditionBox
